import { NavLink, Route, Routes } from 'react-router-dom';
import { useAppBasePath } from '../_shared/base-path';
import { useCurrentUser } from '../_shared/hooks';
import NewRequestPage from './components/NewRequestPage';
import CampaignDetailPage from './components/CampaignDetailPage';
import LinkedInCampaignDetailPage from './components/LinkedInCampaignDetailPage';
import MetaCampaignDetailPage from './components/MetaCampaignDetailPage';
import PerformanceListPage from './components/PerformanceListPage';
import RequestDetailPage from './components/RequestDetailPage';
import ReviewQueuePage from './components/ReviewQueuePage';

function navClassName({ isActive }: { isActive: boolean }) {
  return [
    'rounded-full px-3 py-1.5 text-sm font-medium',
    isActive ? 'bg-bg-secondary text-content-primary' : 'text-content-secondary hover:text-content-primary',
  ].join(' ');
}

export default function AdCommandCenterApp() {
  const { isLoading } = useCurrentUser();
  const base = useAppBasePath();

  if (isLoading) {
    return <div className="p-6 text-content-tertiary">Loading...</div>;
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <nav aria-label="Ad command center" className="flex gap-2">
        <NavLink to={base} end className={navClassName}>
          Review queue
        </NavLink>
        <NavLink to={`${base}/new`} className={navClassName}>
          New request
        </NavLink>
        <NavLink to={`${base}/performance`} className={navClassName}>
          Performance
        </NavLink>
      </nav>
      <Routes>
        <Route index element={<ReviewQueuePage />} />
        <Route path="new" element={<NewRequestPage />} />
        <Route path="performance" element={<PerformanceListPage />} />
        <Route path="performance/meta/:campaignId" element={<MetaCampaignDetailPage />} />
        <Route path="performance/linkedin/:campaignId" element={<LinkedInCampaignDetailPage />} />
        <Route path="performance/:campaignId" element={<CampaignDetailPage />} />
        <Route path="requests/:requestId" element={<RequestDetailPage />} />
      </Routes>
    </div>
  );
}
